
<template>
    <div class="section o-section__max-w c-form--payment" style="margin-top:80px">
        <div class="c-text-section">
            <h1 style="text-align:center">Thank you.</h1>
            <section v-show="fullDetails.payByBankDeposit">
                <div class="c-checkout__deposit" style="line-height:28px">
                    Please make your payment directly into our bank account, use your OrderID as Payment Reference.
                    <br>
                    Artful Dodgers Ltd - ANZ
                    <br>
                    06-0601-0777165-01
                    &nbsp;
                    Order: {{id}}
                    <br>
                    Once your payment as been recieved we will process your order and email you a reciept.
                    <span v-show="cartContents.length == 1">This item is</span>
                    <span v-show="cartContents.length > 1">These items are</span> 
                    made to order and will will be dispatched within 4 weeks.
                </div>
            </section>
            <section v-show="!fullDetails.payByBankDeposit">
                <div class="c-checkout__deposit" style="line-height:28px">
                    Your order (#{{id}}) has been recieved and we have emailed you a reciept.
                    <br>
                    <br>
                    <span v-show="cartContents.length == 1">This item is</span>
                    <span v-show="cartContents.length > 1">These items are</span> 
                    made to order and will will be dispatched within 4 weeks.
                    Once the item is shipped we will email you an update and tracking number
                </div>
            </section>
        </div>
        <section style="c-checkout__checked-out">
            <div class="c-checkout">
                <p class="c-text__title">Customer information</P>
                <p class="c-text__text">{{fullDetails.name}}</p>
                <p class="c-text__text">{{fullDetails.email}}</p>
                <p ng-if="engravingText != ''" class="c-text__text">{{fullDetails.engravingText}}</p>

                <br>
                <p class="c-text__text">{{fullDetails.address.company}}</p>
                <p class="c-text__text">{{fullDetails.address.street}}</p>
                <p class="c-text__text">{{fullDetails.address.street2}}</p>
                <p class="c-text__text">{{fullDetails.address.state}} {{fullDetails.address.zip}}</p>
                <p class="c-text__text">{{fullDetails.address.city}}</p>
                <p class="c-text__text">{{fullDetails.address.country}}</p>

                <br>
                <div ng-if="fullDetails.billingAndShipping!">
                    <p class="c-text__text">{{fullDetails.address2.company}}</p>
                    <p class="c-text__text">{{fullDetails.address2.street}}</p>
                    <p class="c-text__text">{{fullDetails.address2.street2}}</p>
                    <p class="c-text__text">{{fullDetails.address2.state}} {{fullDetails.address2.zip}}</p>
                    <p class="c-text__text">{{fullDetails.address2.city}}</p>
                    <p class="c-text__text">{{fullDetails.address2.country}}</p>
                </div>

            </div>
    
            <div class="c-checkout">
                <div class="c-checkout__cart">
                    <li v-for="(ring, index) in cartContents" :key="ring.id" class="c-cart__item">
                        <img class="c-cart__image" v-bind:src="ring.ring.variations[ring.ring.variationIndex].images[0].url" />
                        <div class="c-cart__item-details">
                            <p class="c-cart__detail">Metal: {{ ring.ring.variations[ring.ring.variationIndex].variation_name }}</p>
                            <span class="c-cart__detail">Size: {{ ring.selectedSize.text }}</span>
                        </div>
                        
                        <div class="c-cart__item-details c-cart__item-details--al-m">
                            <p class="c-cart__price">{{ ring.ring.variations[ring.ring.variationIndex].price[$store.state.currency].formatted }}</p> 
                        </div>
                    </li>
                    <div class="c-cart__totals">
                        <div class="c-cart__subTotal">
                            <span class="c-cart__subTotal-total">TOTAL </span>
                            <span class="c-cart__subTotal-currency">({{$store.state.currency}})</span>
                            <span class="c-cart__subTotal-price">
                                <span v-show="$store.state.currency != 'EUR' && $store.state.currency != 'GBP'">$</span>
                                <span v-show="$store.state.currency == 'EUR'">€</span>
                                <span v-show="$store.state.currency == 'GBP'">£</span>
                                {{total}}
                            </span>
                        </div>
                    </div>
                    <p class="c-checkout__text">Shipping is free on all orders</p>
                </div>
            </div>
            <router-link style="margin-top: 32px !important;" class="c-btn c-btn__link c-btn__link--back" to="/shop">Continue shopping</router-link>
        </section>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                cart:[],
                details:{},
                total: 0,
                // bankPayment: false
            }
        },
        props: ['id'],
        computed: {
            cartContents () {
                var self = this;
                if (this.cart.length > 0){
                    this.cart.forEach(function(item){
                        self.total += item.ring.variations[item.ring.variationIndex].price[self.$store.state.currency].amount / 100;
                    })
                    this.$store.commit('clearCart');
                }
                return this.cart;
            },
            fullDetails () {
                // if (this.$store.state.details.payByBankDeposit){
                //     this.bankPayment = true;
                // } else {
                //     this.bankPayment = false;
                // }
                return this.$store.state.details;
            }
        },
        watch: {
            cartContents: function(newVal, oldVal){
                // console.log("in the cart ", newVal);
            },
            deep: true
        },
        methods: {
        },
         mounted () {
            var self = this;
            if (window.matchMedia("(max-width:765px)").matches){
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            }
            self.cart = JSON.parse ( JSON.stringify (self.$store.state.cart));
            this.$nextTick(function () {

            })
         }
    }
</script>




// WEBPACK FOOTER //
// OrderComplete.vue?0a13dd86